import { Unit } from '../../unit';

export class ThicknessLocationReading {
  thicknessLocationReadingId: string;

  inspectionReportId: string;

  reading: number;
  readingUomId: string;
  readingUom: Unit;

  isIgnored: boolean;
  isInternal: boolean;
  isBaseline: boolean;
  comments: string;

  thicknessLocationId: string;
  locationName: string;
  installDate: Date;
  readingDate: Date = new Date();

  previousReadingValue: number;
  previousReadingUomName: string;
  previousReadingDate: Date;

  nominalThickness: number;
  nominalThicknessUomName: string;

  minimumThickness: number;
  minimumThicknessUomName: string;

  hierarchyItemName: string;

  public json(): any {
    return this;
  }

  public loadFromJson(data) {
    this.thicknessLocationReadingId = data.thicknessLocationReadingId;

    this.inspectionReportId = data.inspectionReportId;
    this.thicknessLocationId = data.thicknessLocationId;

    if (data.previousReading) {
      if (data.previousReading.readingUom) {
        this.previousReadingValue = data.previousReading.reading;
        this.previousReadingUomName = data.previousReading.readingUom.uomName;
      }

      this.previousReadingDate = data.previousReading.readingDate;
    }

    this.reading = data.reading;
    this.readingUomId = data.readingUomId;

    if (data.readingUom) {
      this.readingUom = new Unit();
      this.readingUom.loadFromJson(data.readingUom);
    }

    this.isIgnored = data.isIgnored;
    this.isInternal = data.isInternal;
    this.isBaseline = data.isBaseline;
    this.comments = data.comments;

    if (data.thicknessLocation) {
      this.locationName = data.thicknessLocation.locationName;
      this.installDate = data.thicknessLocation.installDate;

      this.nominalThickness = data.thicknessLocation.nominalThickness;

      if (data.thicknessLocation.nominalThicknessUom) {
        this.nominalThicknessUomName = data.thicknessLocation.nominalThicknessUom.uomName;
      }

      this.minimumThickness = data.thicknessLocation.minimumThickness;

      if (data.thicknessLocation.minimumThicknessUom) {
        this.minimumThicknessUomName = data.thicknessLocation.minimumThicknessUom.uomName;
      }

      this.hierarchyItemName = data.thicknessLocation.orgTreeNode.name;
    }

    if (!this.previousReadingValue) {
      this.previousReadingValue = this.nominalThickness;
      this.previousReadingUomName = this.nominalThicknessUomName;
    }

    if (!this.previousReadingDate || this.previousReadingDate <= new Date('0001-01-01T00:00:00Z')) {
      this.previousReadingDate = this.installDate;
    }
  }

  get readingUomName(): string {
    return this.readingUom && this.readingUom.uomName ? this.readingUom.uomName : '';
  }
}
